import UiReducer from './UiReducer';
import EmployeeReducer from './EmployeeReducer';
import DashBoardReducer from './DashBoardReducer';
import MasterReducer from './MasterReducer';
import UserReducer from './UserReducer';
import RegisterReducer from './RegisterReducer';
import RewardReducer from './RewardReducer';
import PartnerReducer from './PartnerReducer';
import referralReducer from './ReferralReducer';
import ProjectReducer from './ProjectReducer';
import ProjectEmployeeReducer from './ProjectEmployeeReducer';
import ProjectPlanReducer from './ProjectPlanReducer';
import ProjectPlanDayReducer from './ProjectPlanDayReducer';
import ProjectHolidayReducer from './ProjectHolidayReducer';
import SubcontractorReducer from './SubcontractorReducer';
const rootReducer = {
	ui: UiReducer.reducer,	
	employee: EmployeeReducer.reducer,
	dash: DashBoardReducer.reducer,
	master: MasterReducer.reducer,
	user: UserReducer.reducer,
	register: RegisterReducer.reducer,
	reward: RewardReducer.reducer,
	partner: PartnerReducer.reducer,
	referral: referralReducer.reducer,
	project: ProjectReducer.reducer,
	projectEmployee: ProjectEmployeeReducer.reducer,
	projectPlan: ProjectPlanReducer.reducer,
	projectPlanDay: ProjectPlanDayReducer.reducer,
	projectHoliday: ProjectHolidayReducer.reducer,
	subcontractor: SubcontractorReducer.reducer,
};

export default rootReducer;
